<template>
  <div :id="bannerId">
    <div
      class="anz-align-center anz-mt-s anz-bg-orange-light anz-py-m anz-pl-l anz-pr-s anz-b-rounded"
    >
      <h6 class="anz-fs-xs anz-align-items-center">
        <span class="anz-mr-xs">{{ placeHolder }}</span>
        <a-button
          v-if="showLoginLink"
          :add-href="loginBannerFallbackDisabled"
          :href="generateLoginRoute(topic)"
          @click="propagateLoginEvent"
          :title="$translate('post.texts.loginLink')"
          className="anz-link anz-color-primary anz-inline-block anz-link-underline"
        />
      </h6>
    </div>
  </div>
</template>

<script>
import useBannerManager, {
  useDefaultBannerActions,
} from '@/composables/banner/bannerManager'
import { onMounted } from 'vue'
import AButton from '@/components/Forms/AButton'
import AIcon from '@/components/AIcon'
import { useRouter } from '@/routing/router'
import useTopic from '@/composables/topic/topic'

export default {
  name: 'LoginBanner',
  components: { AIcon, AButton },
  props: {
    placeHolder: {
      type: String,
      default: '',
    },
    showLoginLink: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { generateBannerId, propagatePostBannerEvent } = useBannerManager()
    const { topic } = useTopic()
    const bannerId = generateBannerId()

    onMounted(() => {
      propagatePostBannerEvent(bannerId)
    })

    return {
      bannerId,
      topic,
      ...useDefaultBannerActions(),
      ...useRouter(),
    }
  },
}
</script>
